<template>
  <w-sliding-popup ref="passwordModifyPopup" title="패스워드 변경" width="50%" :default-content="false" :close-on-click-modal="false" :before-close="onClickClosePopup" :append-to-body="true" @close="onClickClosePopup">
    <div slot="content" class="body-content-no-scroll" style="height:100%;">
      <el-steps :active="accountPopupActive" finish-status="success">
        <el-step title="계정 확인"></el-step>
        <el-step title="패스워드 변경 수행"></el-step>
        <el-step title="최종 확인"></el-step>
      </el-steps>
      <div v-show="accountPopupActive === 1" style="height:calc(100% - 87px);">
        <el-table-wrapper
          style="height:100%"
          :fit-height="true"
          :data="modifyList"
          :columns="popupColumns['ACCOUNT_CHECK']"
          :show-custom-header="true"
          :show-search-tool="false"
          ref="passwdModifyPopupTable"
          @cell-dblclick="popupModifyColumn"
          :pagination="false"
          :column-default="columnDefault"
        >
          <template slot="delete-slot" slot-scope="scope">
            <span @click="onClickDeletePopupTableRow(scope.$index, modifyList)"><i class="far fa-times c-pointer"></i></span>
          </template>
          <template slot="userPw-slot" slot-scope="scope">
            <el-input v-model="scope.row.userPw" @change="onChangeCheckUserPw(scope.row, scope.$index)" @blur="scope.row.userPwFlag = false"></el-input>
          </template>
        </el-table-wrapper>
      </div>
      <div v-show="accountPopupActive === 2" style="height:calc(100% - 87px);">
        <div class="title-bar">
          총 <em class="mr-l4" style="line-height:1;">{{ modifyList.length }}</em
          >개 장비 계정의 패스워드를 변경합니다.
        </div>
        <el-table-wrapper
          style="height:calc(100% - 31px);"
          :fit-height="true"
          :data="modifyList"
          :columns="popupColumns['PASSWD_MODIFY_EXECUTE']"
          :show-custom-header="true"
          :show-search-tool="false"
          :pagination="false"
          :column-default="columnDefault"
        >
        </el-table-wrapper>
      </div>
      <div v-show="accountPopupActive === 3" style="height:calc(100% - 87px);">
        <el-row class="title-bar vertical-center-box">
          <el-select class="mr-r10" style="width:80px;" v-model="popupModifyHistState" size="mini">
            <el-option
              v-for="item in [
                { label: '전체', value: 'all' },
                { label: '성공', value: 'Y' },
                { label: '실패', value: 'N' },
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              width="60"
            >
            </el-option>
          </el-select>
          <span
            >{{ modifyList.length }}개 장비 계정 패스워드 변경 수행 (성공: <span class="state-normal">{{ successCount }}</span> / 실패: <span class="state-abnormal">{{ failurCount }}</span
            >)</span
          >
        </el-row>
        <el-table-wrapper
          v-loading="passwdModifyLoading"
          style="height:calc(100% - 38px);"
          :fit-height="true"
          :data="modifyHistData"
          :columns="popupColumns['FINISH_CHECK']"
          :show-custom-header="true"
          :show-search-tool="false"
          :pagination="false"
          :column-default="columnDefault"
        >
          <template slot-scope="scope" slot="status-slot">
            <span class="state-normal" v-if="scope.row.status === 'Y'">성공</span>
            <span class="state-abnorma" v-else>실패</span>
          </template>
        </el-table-wrapper>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-row type="flex" justify="end" v-show="accountPopupActive === 1">
        <el-button class="mr-r4" size="large" type="solid" @click="onClickAccountPopupNext">다음</el-button>
        <el-button size="large" @click="$refs.passwordModifyPopup.close()">취소</el-button>
      </el-row>
      <el-row type="flex" justify="space-between" v-show="accountPopupActive === 2">
        <el-button size="large" @click="accountPopupActive = 1"> <i class="fal fa-arrow-left mr-r2"></i>이전 </el-button>
        <div>
          <el-button size="large" type="solid" @click="onClickModifyExecuteClick">변경</el-button>
          <el-button size="large" @click="$refs.passwordModifyPopup.close()">취소</el-button>
        </div>
      </el-row>
      <el-row type="flex" justify="end" v-show="accountPopupActive === 3">
        <el-button size="large" @click="$refs.passwordModifyPopup.close()">닫기</el-button>
      </el-row>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, assign, cloneDeep, forEach } from 'lodash';
import msgUtil from '@/utils/message';
import { PASSWORD_FOR_VIEW } from '@/constants/common';
import { mapGetters } from 'vuex';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { columnDefault } from '@/constants/table';
import { getRsaEncryptBulk } from '@/utils/rsa-encrypt';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';

export default {
  name: 'WPassWordModifyPopup',
  props: {
    selectedRow: {
      type: Array,
    },
    objId: {
      type: Number,
    },
  },
  data() {
    return {
      originList: [],
      modifyList: [],
      modifyResultData: [],
      modifyHistData: [],
      successCount: 0,
      failurCount: 0,
      columnDefault,
      passwdModifyLoading: false,
      currentRow: null,
      popupModifyHistState: 'all',
      accountPopupActive: 1,
      changePasswordTask: 'changePasswordTask',
      popupColumns: {
        ACCOUNT_CHECK: [
          {
            prop: 'objName',
            label: '장비명',
            sortable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ipaddress',
            label: 'IP',
            sortable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'userId',
            label: '계정ID',
            sortable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'beforePw',
            label: '기존 비밀번호',
            formatter: this.passwdConvert,
          },
          {
            prop: 'userPw',
            label: '변경 비밀번호',
            scopedSlot: 'userPw-slot',
          },
          {
            label: '삭제',
            align: 'center',
            width: 50,
            scopedSlot: 'delete-slot',
          },
        ],
        PASSWD_MODIFY_EXECUTE: [
          {
            prop: 'objName',
            label: '장비명',
            sortable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ipaddress',
            label: 'IP',
            sortable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'userId',
            label: '계정ID',
            sortable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'beforePw',
            label: '기존 비밀번호',
            formatter: this.passwdConvert,
          },
          {
            prop: 'userPw',
            label: '변경 비밀번호',
            formatter: this.getTableValueAfterCheckEmpty,
          },
        ],
        FINISH_CHECK: [
          {
            prop: 'STATUS',
            label: '상태',
            scopedSlot: 'status-slot',
          },
          {
            prop: 'objName',
            label: '장비명',
            sortable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ipaddress',
            label: 'IP',
            sortable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'userId',
            label: '아이디',
            sortable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'beforePw',
            label: '비밀번호',
            sortable: true,
            formatter: this.passwdConvert,
          },
        ],
      },
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    /**
     * [popupModifyHistState 패스워드변경 팝업 - 패스워드 변경 결과 콤보박스 필터링 처리]
     * @author {Yang}
     * @param  {[type]} state [description]
     * @return {[type]}       [description]
     */
    popupModifyHistState: {
      handler(state) {
        this.setModifyHistStateData(state);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.$taskManager.existTask(this.changePasswordTask)) {
      this.$taskManager.removeTask(this.changePasswordTask);
    }
  },
  methods: {
    /**
     * [onClickDeletePopupTableRow 패스워드변경 팝업 - 1스텝에서 row 삭제시 한개 이상 데이터 삭제 불가 처리]
     * @author {Yang}
     * @param  {[type]} index [description]
     * @param  {[type]} rows  [description]
     * @return {[type]}       [description]
     */
    onClickDeletePopupTableRow(index, rows) {
      if (this.modifyList.length === 1) {
        this.$message('최소 하나의 계정 정보는 있어야합니다.');
      } else {
        rows.splice(index, 1);
      }
    },
    /**
     * [onChangeCheckUserPw 패스워드 변경팝업 비밀번호 유효성 검사]
     * nextFlag - 2뎁스로 넘어갈 다음 버튼 flag처리
     * @author {Yang}
     * @param  {[type]}  value [description]
     * @return {Boolean}       [description]
     */
    onChangeCheckUserPw(row, index) {
      let pattern = /\s/g;
      if (pattern.test(row.userPw)) {
        this.$message('비밀번호에 공백이 포함될 수 없습니다.');
        this.modifyList[index].userPw = '';
        return false;
      }
      pattern = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
      if (pattern.test(row.userPw)) {
        this.$message('비밀번호에 한글이 포함될 수 없습니다.');
        this.modifyList[index].userPw = '';
        return false;
      }
      row.nextFlag = true;
      return true;
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [convertDatetime 테이블 날짜 포맷 설정]
     * @author {Yang}
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    convertDatetime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    /**
     * [onClickAccountPopupNext 패스워드 변경팝업 다음 버튼 누를시 정규식 호출 ]
     * nextFlag - 2뎁스로 넘어갈 다음 버튼 flag처리
     * @author {Yang}
     * @return {[type]}       [description]
     */
    onClickAccountPopupNext() {
      let flag = true;
      forEach(this.modifyList, (row) => {
        if (flag && !row.nextFlag) {
          this.$message(msgUtil.getCustomMsgData('모든 계정의 변경 비밀번호를 입력해주십시오.'));
          flag = false;
        }
      });
      if (flag) {
        if (this.modifyList.length > 0) {
          this.accountPopupActive = 2;
        } else {
          this.$message(msgUtil.getCustomMsgData('패스워드를 변경할 계정이 없습니다.'));
        }
      }
    },
    /**
     * [onClickModifyExecuteClick 패스워드 변경 처리]
     * @author {Yang}
     * TODO task 처리 필요, 프로그래스바 처리. , 팝업의 퍼블리싱 필요
     * @return {[type]} [description]
     */
    onClickModifyExecuteClick() {
      const managegroupId = this.selectedNode.type === 'obj' ? this.selectedNode.parent.managegroupId : this.selectedNode.managegroupId;
      const me = this;
      this.$confirm(...msgUtil.getBasicConfirmData('패스워드를 변경'))
        .then(() => {
          /* 패스워드변경 history 출력 */
          me.passwdModifyLoading = true;
          /* 패스워드 변경 */
          const changePwAccounts = cloneDeep(me.modifyList);
          getRsaEncryptBulk(changePwAccounts, ['userPw'])
            .then((encryptDatas) => {
              netdeviceInfoAPI
                .getNetdeviceConfigInfochangePassword(encryptDatas)
                .then((result) => {
                  if (result.data.success === true) {
                    /* 패스워드변경 history 출력 */
                    this.$taskManager.createTask(
                      this.changePasswordTask,
                      1,
                      () => {
                        netdeviceInfoAPI
                          .getNetdeviceConfigInfoHistoryAccountList({
                            managegroupId,
                            objId: this.objId,
                            histSeq: result.data.data,
                          })
                          .then((histResult) => {
                            if (histResult.data.success === true) {
                              me.modifyResultData = histResult.data.data;
                              me.accountPopupActive = 3;
                              me.setModifyHistStateData('all');
                              if (me.modifyResultData.length > 0) {
                                me.passwdModifyLoading = false;
                                me.$taskManager.removeTask(this.changePasswordTask);
                              }
                            }
                          });
                      },
                      false,
                      60,
                      () => {
                        me.passwdModifyLoading = false;
                        me.$message(msgUtil.getCustomResultMsgData('시간 초과로 패스워드 변경 결과를 확인하지 못하였습니다.', false));
                      },
                    );
                    this.$taskManager.startTask(this.changePasswordTask);
                  } else {
                    me.passwdModifyLoading = false;
                    this.$message(msgUtil.getResultMsgData('변경', '패스워드', false));
                  }
                })
                .catch(() => {
                  me.passwdModifyLoading = false;
                  this.$message(msgUtil.getResultMsgData('변경', '패스워드', false));
                });
            })
            .catch((e) => {
              this.$message(msgUtil.getResultMsgData('변경', '패스워드', false));
              throw new Error(e);
            });
        })
        .catch(() => {});
    },
    setModifyHistStateData(state) {
      this.modifyHistData = [];
      this.successCount = 0;
      this.failurCount = 0;
      const successData = [];
      const failurData = [];
      forEach(this.modifyResultData, (value) => {
        if (value.status === 'Y') {
          successData.push(value);
          this.successCount += 1;
        }
      });
      forEach(this.modifyResultData, (value) => {
        if (value.status === 'N') {
          failurData.push(value);
          this.failurCount += 1;
        }
      });
      switch (state) {
        case 'Y':
          this.modifyHistData = successData;
          break;
        case 'N':
          this.modifyHistData = failurData;
          break;
        default:
          this.modifyHistData = this.modifyResultData;
      }
    },
    /**
     * [popupModifyColumn 컬럼 더블클릭시 input 활성화]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    popupModifyColumn(row) {
      this.$set(row, 'userPwFlag', true);
    },
    /**
     * [passwdConvert 패스워드 컬럼 포맷터]
     * @author {Yang}
     * @return {[type]} [description]
     */
    passwdConvert() {
      return PASSWORD_FOR_VIEW;
    },
    /**
     * [getSlotValueEmptyCheck slot의 빈값 체크]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getSlotValueEmptyCheck(value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [onClickClosePopup 패스워드 변경 팝업 닫기- deviceaccount 테이블 선택 제거]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickClosePopup() {
      if (this.accountPopupActive === 3) {
        this.modifyList = [];
        this.$emit('close');
      } else {
        this.modifyList = cloneDeep(this.originList);
      }
      this.accountPopupActive = 1;
      if (this.$taskManager.existTask(this.changePasswordTask)) {
        this.$taskManager.removeTask(this.changePasswordTask);
      }
    },
    /**
     * [open 팝업 열기]
     * props에 따라 넘어오는 modifyList를 정해준다.
     * @author {Yang}
     * @return {[type]} [description]
     */
    open() {
      if (!isNil(this.selectedRow)) {
        this.modifyList = cloneDeep(this.selectedRow);
        this.originList = cloneDeep(this.selectedRow);
      } else if (!isNil(this.objId)) {
        netdeviceInfoAPI
          .getNetdeviceConfigInfoDeviceAccountList({
            objId: this.objId,
          })
          .then((result) => {
            if (result.data.success === true) {
              this.modifyList = result.data.data;
              this.originList = result.data.data;
            }
          });
      }
      this.$refs.passwordModifyPopup.open();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/popup/PassWordModifyPopup.vue